import React, { useState, useEffect } from "react";
import "./CustomGrid.css";

/**
 * Componente de input customizado para uso dentro do CustomGrid.
 *
 * Props:
 * - value: valor inicial
 * - rowId: id da linha
 * - onChange(rowId, newValue): callback disparado ao sair do campo (onBlur)
 * - placeholder: texto exibido quando vazio
 * - width: largura (default: 100px)
 * - height: altura (default: 24px)
 * - style: estilo adicional
 */
export default function RowInput({
  value = "",
  rowId,
  onBlur = () => {},
  placeholder = "",
  width = "100px",
  height = "24px",
  style = {},
}) {
  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const handleBlur = () => {
    if (inputValue !== value) {
      onBlur(rowId, inputValue);
    }
  };

  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f9f9f9",
        borderRadius: 4,
        padding: "0 4px",
        border: "1px solid #ddd",
        width,
        height,
        ...style,
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <input
        type="text"
        value={inputValue}
        placeholder={placeholder}
        onChange={(e) => setInputValue(e.target.value)}
        onBlur={handleBlur}
        style={{
          width: "100%",
          height: "100%",
          border: "none",
          outline: "none",
          background: "transparent",
          textAlign: "center",
          fontSize: "12px",
          color: "#333",
        }}
      />
    </div>
  );
}
